<template>
  <div>
      <ul class="rew19_clear rew19_receipt_lineup">
        <li class="rew19_wrapRadio_t1 rew19_lineup_left">
          <input
            v-model="wholesale_receipt"
            id="wholesale_receipt1"
            class="rew19_fakeRadio_t1"
            type="radio"
            value="Y"
            checked="checked"
          />
          <label for="wholesale_receipt1">도매용</label>
        </li>

        <li class="rew19_wrapRadio_t1 rew19_lineup_left">
          <input
            v-model="wholesale_receipt"
            id="wholesale_receipt2"
            class="rew19_fakeRadio_t1"
            type="radio"
            value="N"
          />
          <label for="wholesale_receipt2">소매용</label>
        </li>
      </ul>
      <p class="rew19_infoStar_wrap">
        <span
          class="rew19_infoStar"
        >부가가치세 매입세액 공제 및 증빙용 세금계산서 발급을 원하시는 경우, <b>결제 전에 반드시 본인 명의의 사업자등록증</b>을 당사에 제출해주시기 바랍니다.</span>
      </p>
      <div class="rew19_clear rew19_indetailBt">
        <button type="button" class="rew19_btnDetail down">
          <span>자세히 보기</span>
        </button>
      </div>
      <div class="rew19_paymentDon" style="display:none">
        <span class="rew18_infoTxt">사업자등록증에 기재된 <b>대표자 성명과 회원(주문자)의 명의가 일치해야 하며</b>, 불일치할 경우 사업자등록 및 세금계산서 발급이 불가합니다. 사업자등록증 제출은 <b>회원정보와 함께 아래 이메일 주소로 보내주시기 바랍니다.</b></span>
        <span class="rew18_infoTxt"><a href="mailto:ds_kr@nuskin.com">📧 ds_kr@nuskin.com</a></span>
      </div>
  </div>
</template>
<script>
export default {
  name: "Receipt",
  data() {
    return{
      wholesale_receipt: "Y"
    }
  },
  mounted() {
    let _this = this;
    _this.initUi();
  },
  methods: {
    initUi(){},
    getData(){
      let _this = this;

      return _this.wholesale_receipt;
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/payment/Receipt.vue